// Models
import { IFormInputs, IModelInput } from 'models'
import { IWorkoutRoutineState } from 'storage/workoutRoutine/models'
import IStore from 'lib/redux/models'

// React
import { FC, useContext } from 'react'

// Libraries
import { FormProvider, useForm } from 'react-hook-form'
import { ThemeContext } from 'styled-components'
import { useSelector } from 'react-redux'

// Constants
import * as Styled from './styled'
import { Body } from 'heeds-ds'
import { SeriesFormTag, SpecialSeriesFormTag } from 'components'
import { ModalContent, ModalHeader } from 'components/UI/Containers'
import { Modal } from 'components/modals'

type Props = {
  selectedModelIndex: number
  stateModels: IModelInput[]
}

const ModalWorkoutModel: FC<Props> = ({ selectedModelIndex, stateModels }) => {
  const { workoutRoutine } = useSelector<IStore, IWorkoutRoutineState>(
    (state) => state.workoutRoutine,
  )
  const theme = useContext(ThemeContext)

  const methods = useForm<IFormInputs>({
    defaultValues: { models: stateModels },
  })

  return (
    <Modal>
      <ModalHeader>
        <Body type="copy1" color={theme.colors.text.secondary} weight={600}>
          {workoutRoutine?.name}
        </Body>
      </ModalHeader>

      <ModalContent>
        <Body type="copy4" color={theme.colors.text.disabled} margin="0 0 24px">
          Esses foram os exercícios que você selecionou para o seu aluno nesse
          treino.
        </Body>

        <Styled.ScrollModal>
          <FormProvider {...methods}>
            {stateModels.map((stateModel, modelIndex) => {
              return Object.values(stateModel.workout_set).map(
                (stateSet, setIndex) => {
                  const fieldName = `models.${modelIndex}.workout_set.${stateSet.id}`

                  if (stateSet.type === 'normal') {
                    return (
                      <Styled.ShowList
                        key={stateSet.id}
                        isVisible={modelIndex === selectedModelIndex}
                      >
                        <SeriesFormTag
                          displayMode
                          key={stateSet.id}
                          exercise={stateSet?.exercises[0]?.exercise}
                          name={fieldName}
                          onRemove={() => undefined}
                          readonly
                          visible
                        />
                      </Styled.ShowList>
                    )
                  } else {
                    return (
                      <Styled.ShowList
                        key={stateSet.id}
                        isVisible={modelIndex === selectedModelIndex}
                      >
                        <SpecialSeriesFormTag
                          displayMode
                          name={fieldName}
                          readonly
                          workoutSet={{ ...stateSet, index: setIndex }}
                        />
                      </Styled.ShowList>
                    )
                  }
                },
              )
            })}
          </FormProvider>
        </Styled.ScrollModal>
      </ModalContent>
    </Modal>
  )
}

export default ModalWorkoutModel
